"use strict";
/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_SHARED_FUNCTIONALITY_KEY = exports.fetchPostSharedUniversalPayLinkPayLink = exports.POST_SHARED_UNIVERSAL_PAY_LINK_PAY_LINK_KEY = exports.fetchPostSharedPayNowConfirmationEmail = exports.POST_SHARED_PAY_NOW_CONFIRMATION_EMAIL_KEY = exports.fetchPostSharedPayLinkPackagePayLink = exports.POST_SHARED_PAY_LINK_PACKAGE_PAY_LINK_KEY = exports.fetchPostSharedPayLinkPayNow = exports.POST_SHARED_PAY_LINK_PAY_NOW_KEY = exports.fetchGetSellerWebhooks = exports.GET_SELLER_WEBHOOKS_KEY = exports.fetchGetSellerSpendingLimitRequest = exports.GET_SELLER_SPENDING_LIMIT_REQUEST_KEY = exports.fetchPostSellerResendInvite = exports.POST_SELLER_RESEND_INVITE_KEY = exports.fetchPutSellerPricing = exports.PUT_SELLER_PRICING_KEY = exports.fetchGetSellerPricing = exports.GET_SELLER_PRICING_KEY = exports.fetchPostSellerPayLinkPackage = exports.POST_SELLER_PAY_LINK_PACKAGE_KEY = exports.fetchGetSellerPayLinkPackage = exports.GET_SELLER_PAY_LINK_PACKAGE_KEY = exports.fetchGetSellerPayLinkDownload = exports.GET_SELLER_PAY_LINK_DOWNLOAD_KEY = exports.fetchPutSellerPayLink = exports.PUT_SELLER_PAY_LINK_KEY = exports.fetchPostSellerPayLink = exports.POST_SELLER_PAY_LINK_KEY = exports.fetchGetSellerPayLink = exports.GET_SELLER_PAY_LINK_KEY = exports.fetchGetSellerConnection = exports.GET_SELLER_CONNECTION_KEY = exports.fetchGetSellerBranding = exports.GET_SELLER_BRANDING_KEY = exports.fetchPutSellerAccessUser = exports.PUT_SELLER_ACCESS_USER_KEY = exports.fetchPostSellerAccessUser = exports.POST_SELLER_ACCESS_USER_KEY = exports.fetchGetSellerAccessUser = exports.GET_SELLER_ACCESS_USER_KEY = exports.fetchDeleteSellerAccessUser = exports.DELETE_SELLER_ACCESS_USER_KEY = exports.fetchGetBuyerSpendingLimit = exports.GET_BUYER_SPENDING_LIMIT_KEY = exports.fetchGetBuyerSellerDirectory = exports.GET_BUYER_SELLER_DIRECTORY_KEY = exports.LapiError = exports.fetchLendingAPIJSON = exports.fetchLendingAPI = void 0;
exports.fetchPostSharedUserAction = exports.POST_SHARED_USER_ACTION_KEY = exports.fetchPostSharedRegisterInterest = exports.POST_SHARED_REGISTER_INTEREST_KEY = exports.fetchGetSharedRegisterInterest = exports.GET_SHARED_REGISTER_INTEREST_KEY = exports.fetchGetSharedFunctionality = void 0;
const lendingAPI_1 = require("./lendingAPI");
var lendingAPI_2 = require("./lendingAPI");
Object.defineProperty(exports, "fetchLendingAPI", { enumerable: true, get: function () { return lendingAPI_2.fetchLendingAPI; } });
Object.defineProperty(exports, "fetchLendingAPIJSON", { enumerable: true, get: function () { return lendingAPI_2.fetchLendingAPIJSON; } });
Object.defineProperty(exports, "LapiError", { enumerable: true, get: function () { return lendingAPI_2.LapiError; } });
exports.GET_BUYER_SELLER_DIRECTORY_KEY = "getBuyerSellerDirectory";
/**
 * No description
 */
function fetchGetBuyerSellerDirectory({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/buyer/${stateKey}/seller_directory/`, {
        method: "get",
    });
}
exports.fetchGetBuyerSellerDirectory = fetchGetBuyerSellerDirectory;
exports.GET_BUYER_SPENDING_LIMIT_KEY = "getBuyerSpendingLimit";
/**
 * No description
 */
function fetchGetBuyerSpendingLimit({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/buyer/${stateKey}/spending_limit/`, {
        method: "get",
    });
}
exports.fetchGetBuyerSpendingLimit = fetchGetBuyerSpendingLimit;
exports.DELETE_SELLER_ACCESS_USER_KEY = "deleteSellerAccessUser";
/**
 * No description
 */
function fetchDeleteSellerAccessUser({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/iwocapay/seller/${stateKey}/access_user/`, {
        method: "delete",
        body,
    });
}
exports.fetchDeleteSellerAccessUser = fetchDeleteSellerAccessUser;
exports.GET_SELLER_ACCESS_USER_KEY = "getSellerAccessUser";
/**
 * No description
 */
function fetchGetSellerAccessUser({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/seller/${stateKey}/access_user/`, {
        method: "get",
    });
}
exports.fetchGetSellerAccessUser = fetchGetSellerAccessUser;
exports.POST_SELLER_ACCESS_USER_KEY = "postSellerAccessUser";
/**
 * No description
 */
function fetchPostSellerAccessUser({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/iwocapay/seller/${stateKey}/access_user/`, {
        method: "post",
        body,
    });
}
exports.fetchPostSellerAccessUser = fetchPostSellerAccessUser;
exports.PUT_SELLER_ACCESS_USER_KEY = "putSellerAccessUser";
/**
 * No description
 */
function fetchPutSellerAccessUser({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/iwocapay/seller/${stateKey}/access_user/`, {
        method: "put",
        body,
    });
}
exports.fetchPutSellerAccessUser = fetchPutSellerAccessUser;
exports.GET_SELLER_BRANDING_KEY = "getSellerBranding";
/**
 * No description
 */
function fetchGetSellerBranding({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/seller/${stateKey}/branding/`, {
        method: "get",
    });
}
exports.fetchGetSellerBranding = fetchGetSellerBranding;
exports.GET_SELLER_CONNECTION_KEY = "getSellerConnection";
/**
 * No description
 */
function fetchGetSellerConnection({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/seller/${stateKey}/connection/`, {
        method: "get",
    });
}
exports.fetchGetSellerConnection = fetchGetSellerConnection;
exports.GET_SELLER_PAY_LINK_KEY = "getSellerPayLink";
/**
 * No description
 */
function fetchGetSellerPayLink({ stateKey, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/seller/${stateKey}/pay_link/`, {
        method: "get",
        query,
    });
}
exports.fetchGetSellerPayLink = fetchGetSellerPayLink;
exports.POST_SELLER_PAY_LINK_KEY = "postSellerPayLink";
/**
 * No description
 */
function fetchPostSellerPayLink({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/seller/${stateKey}/pay_link/`, {
        method: "post",
        body,
    });
}
exports.fetchPostSellerPayLink = fetchPostSellerPayLink;
exports.PUT_SELLER_PAY_LINK_KEY = "putSellerPayLink";
/**
 * No description
 */
function fetchPutSellerPayLink({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/seller/${stateKey}/pay_link/`, {
        method: "put",
        body,
    });
}
exports.fetchPutSellerPayLink = fetchPutSellerPayLink;
exports.GET_SELLER_PAY_LINK_DOWNLOAD_KEY = "getSellerPayLinkDownload";
/**
 * No description
 */
function fetchGetSellerPayLinkDownload({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/iwocapay/seller/${stateKey}/pay_link_download/`, {
        method: "get",
    });
}
exports.fetchGetSellerPayLinkDownload = fetchGetSellerPayLinkDownload;
exports.GET_SELLER_PAY_LINK_PACKAGE_KEY = "getSellerPayLinkPackage";
/**
 * No description
 */
function fetchGetSellerPayLinkPackage({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/seller/${stateKey}/pay_link_package/`, {
        method: "get",
    });
}
exports.fetchGetSellerPayLinkPackage = fetchGetSellerPayLinkPackage;
exports.POST_SELLER_PAY_LINK_PACKAGE_KEY = "postSellerPayLinkPackage";
/**
 * No description
 */
function fetchPostSellerPayLinkPackage({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/seller/${stateKey}/pay_link_package/`, {
        method: "post",
        body,
    });
}
exports.fetchPostSellerPayLinkPackage = fetchPostSellerPayLinkPackage;
exports.GET_SELLER_PRICING_KEY = "getSellerPricing";
/**
 * No description
 */
function fetchGetSellerPricing({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/seller/${stateKey}/pricing/`, {
        method: "get",
    });
}
exports.fetchGetSellerPricing = fetchGetSellerPricing;
exports.PUT_SELLER_PRICING_KEY = "putSellerPricing";
/**
 * No description
 */
function fetchPutSellerPricing({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/seller/${stateKey}/pricing/`, {
        method: "put",
        body,
    });
}
exports.fetchPutSellerPricing = fetchPutSellerPricing;
exports.POST_SELLER_RESEND_INVITE_KEY = "postSellerResendInvite";
/**
 * No description
 */
function fetchPostSellerResendInvite({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/iwocapay/seller/${stateKey}/resend_invite/`, {
        method: "post",
        body,
    });
}
exports.fetchPostSellerResendInvite = fetchPostSellerResendInvite;
exports.GET_SELLER_SPENDING_LIMIT_REQUEST_KEY = "getSellerSpendingLimitRequest";
/**
 * No description
 */
function fetchGetSellerSpendingLimitRequest({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/seller/${stateKey}/spending_limit_request/`, {
        method: "get",
    });
}
exports.fetchGetSellerSpendingLimitRequest = fetchGetSellerSpendingLimitRequest;
exports.GET_SELLER_WEBHOOKS_KEY = "getSellerWebhooks";
/**
 * No description
 */
function fetchGetSellerWebhooks({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/seller/${stateKey}/webhooks/`, {
        method: "get",
    });
}
exports.fetchGetSellerWebhooks = fetchGetSellerWebhooks;
exports.POST_SHARED_PAY_LINK_PAY_NOW_KEY = "postSharedPayLinkPayNow";
/**
 * No description
 */
function fetchPostSharedPayLinkPayNow({ payLinkId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/shared/pay_link/${payLinkId}/pay_now/`, {
        method: "post",
        body,
    });
}
exports.fetchPostSharedPayLinkPayNow = fetchPostSharedPayLinkPayNow;
exports.POST_SHARED_PAY_LINK_PACKAGE_PAY_LINK_KEY = "postSharedPayLinkPackagePayLink";
/**
 * No description
 */
function fetchPostSharedPayLinkPackagePayLink({ payLinkPackageId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/shared/pay_link_package/${payLinkPackageId}/pay_link/`, {
        method: "post",
        body,
    });
}
exports.fetchPostSharedPayLinkPackagePayLink = fetchPostSharedPayLinkPackagePayLink;
exports.POST_SHARED_PAY_NOW_CONFIRMATION_EMAIL_KEY = "postSharedPayNowConfirmationEmail";
/**
 * No description
 */
function fetchPostSharedPayNowConfirmationEmail({ paymentId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/iwocapay/shared/pay_now/${paymentId}/confirmation_email/`, {
        method: "post",
        body,
    });
}
exports.fetchPostSharedPayNowConfirmationEmail = fetchPostSharedPayNowConfirmationEmail;
exports.POST_SHARED_UNIVERSAL_PAY_LINK_PAY_LINK_KEY = "postSharedUniversalPayLinkPayLink";
/**
 * No description
 */
function fetchPostSharedUniversalPayLinkPayLink({ sellerHandle, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/shared/universal_pay_link/${sellerHandle}/pay_link/`, {
        method: "post",
        body,
    });
}
exports.fetchPostSharedUniversalPayLinkPayLink = fetchPostSharedUniversalPayLinkPayLink;
exports.GET_SHARED_FUNCTIONALITY_KEY = "getSharedFunctionality";
/**
 * No description
 */
function fetchGetSharedFunctionality({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/shared/${stateKey}/functionality/`, {
        method: "get",
    });
}
exports.fetchGetSharedFunctionality = fetchGetSharedFunctionality;
exports.GET_SHARED_REGISTER_INTEREST_KEY = "getSharedRegisterInterest";
/**
 * No description
 */
function fetchGetSharedRegisterInterest({ stateKey, feature, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/shared/${stateKey}/register_interest/${feature}/`, {
        method: "get",
    });
}
exports.fetchGetSharedRegisterInterest = fetchGetSharedRegisterInterest;
exports.POST_SHARED_REGISTER_INTEREST_KEY = "postSharedRegisterInterest";
/**
 * No description
 */
function fetchPostSharedRegisterInterest({ stateKey, feature, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/shared/${stateKey}/register_interest/${feature}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostSharedRegisterInterest = fetchPostSharedRegisterInterest;
exports.POST_SHARED_USER_ACTION_KEY = "postSharedUserAction";
/**
 * No description
 */
function fetchPostSharedUserAction({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/iwocapay/shared/${stateKey}/user_action/`, {
        method: "post",
        body,
    });
}
exports.fetchPostSharedUserAction = fetchPostSharedUserAction;
